/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useCallback } from "react";
import { useGenerateCronFromPhraseMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";

export function useGenerateCronFromPhrase() {
  const [generateCronFromPhraseMutation, { data, loading }] =
    useGenerateCronFromPhraseMutation({
      onError: (error) => showError(error.message),
    });

  const generateCronFromPhrase = useCallback(
    (inputPhrase: string) =>
      generateCronFromPhraseMutation({
        variables: {
          input: {
            phrase: inputPhrase,
          },
        },
        fetchPolicy: "no-cache",
      }),
    [generateCronFromPhraseMutation]
  );

  return { generateCronFromPhrase, data, loading } as const;
}
